module.exports = __webpack_public_path__ + "img/user03.4bbeda70.png";